import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { View, Pressable, Text } from 'react-native';
import styled from 'styled-components/native';
import {
  ContentContainer,
  LinkSpace,
  MainContainer,
  PageTitle
} from '../../../elements';
import { useQuery } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import { elRed, elGray } from '../../../styles/colors';
import { FEE_ESTIMATE } from './queries';
import EstimateFunctions from './EstimateFunctions';
import FeeEstimateFunctionsLegend from './EstimateFunctionsLegend';
import ResourceNotifications from '../../Notifications/Resource';
import { currency } from '../../../utils/stringHelpers';
import currencyFormatter from '../../../utils/currencyFormatter';
import { Link } from 'app/src/utils/routing';

const FeeEstimateContainer = styled(View)`
  margin: 20px;
  border: solid 1px black;
  border-radius: 5px;
  background-color: ${elGray}
`;

const AssetDetails = styled(View)`
  display: flex;
  flex-direction: row;
  margin: 20px;
`;

const FeeEstimateDetails = styled(View)`
  display: flex;
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
`;

const FeeEstimate = () => {
  const { assetId, feeEstimateId } = useParams();

  const { loading, error, data, refetch } = useQuery(
    FEE_ESTIMATE, { variables: { id: feeEstimateId } }
  );

  if(loading) {
    return <DataState.Loading />;
  }

  const feeEstimate = data?.feeEstimate;
  const asset = feeEstimate?.asset;

  return (
    <View>
      <MainContainer>
        <ContentContainer>
          <View style={{display: 'flex', flexDirection: 'row'}}>
            <PageTitle>Fee Estimate</PageTitle>
            <ResourceNotifications
              resource={feeEstimate}
            />
          </View>
          <FeeEstimateContainer>
            <FeeEstimateFunctionsLegend />
            <AssetDetails>
              <Text>{asset?.name}</Text>
              <Link to={`/assets/${asset.id}`}>
                <Text>{'  '}(View Asset)</Text>
              </Link>
              <LinkSpace />
              <Text><b>Stock #: </b>{asset?.stockNumber}</Text>
              <LinkSpace />
              <Text><b>VIN: </b>{asset?.vin}</Text>
              <LinkSpace />
              <Text><b>Category: </b>{asset?.category}</Text>
            </AssetDetails>
            <FeeEstimateDetails>
              <Text><b>Status: </b>{feeEstimate.status}</Text>
              <Text><b>Type: </b>{feeEstimate.type}</Text>
              <LinkSpace />
              <Text>
                <b>
                  { feeEstimate.counterAmount ?
                    'Original Amount: ' :
                    'Amount: '
                  }
                </b>{currency(feeEstimate.amount)}
              </Text>
              {feeEstimate.counterAmount &&
                <View>
                  <Text>
                    <b>Counter Amount: </b>{currency(feeEstimate.counterAmount)}
                  </Text>
                  <LinkSpace />
                </View>
              }
            </FeeEstimateDetails>
            {feeEstimate.activeFor === 'SellerUser' &&
              <EstimateFunctions feeEstimate={feeEstimate} refetch={refetch} />
            }
            <br />
          </FeeEstimateContainer>
        </ContentContainer>
      </MainContainer>
    </View>
  )
}

export default FeeEstimate;
